module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStd-Black.4fbd2bf.otf";


//////////////////
// WEBPACK FOOTER
// ./src/css/AvenirLTStd-Black.otf
// module id = xNWo
// module chunks = 1